import { render, staticRenderFns } from "./AModalProviderSelector.vue?vue&type=template&id=ce84c50c"
import script from "./AModalProviderSelector.vue?vue&type=script&lang=js"
export * from "./AModalProviderSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports